module.exports = __webpack_public_path__ + "static/img/y1.fd0f725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y1.png
// module id = LFu6
// module chunks = 1